import { isNullOrUndefined } from "@qntm-code/utils";
import { SolutionManager } from "./solution-manager";

export class OrgAsset extends SolutionManager {

  type: string;
  description: string;
  mandatory: boolean;

  empClassMapping: OrgAssetEmpClassMapping[];
  messageTemplateId?: number;
  messageTemplateName?: string;
  vendorId: number;
  vendorName: string;
  workgroupId: number;
  workgroupName?: string;

  constructor (managingOrgId?: number) {
    super();
    if (!isNullOrUndefined(managingOrgId)) { this.orgId = managingOrgId; }
  }
}

export class OrgAssetEmpClassMapping {
  id?: number;
  version?: number;
  orgAssetId: number;
  empClassId: number;
  empClassName: string;
}
